export function formatDuration(seconds: number): string {
  const total = Math.max(0, Math.round(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const remainder = total % 60;
  return hours > 0
    ? `${hours}:${String(minutes).padStart(2, "0")}:${String(remainder).padStart(2, "0")}`
    : `${minutes}:${String(remainder).padStart(2, "0")}`;
}

export function formatDate(date: Date | null): string {
  if (!date || date.valueOf() === 0) return "Not provided";
  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
}

export function formatFileSize(bytes: number): string {
  const safeBytes = Math.max(0, bytes);
  if (safeBytes < 1024) return `${safeBytes} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let value = safeBytes / 1024;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  return `${value >= 100 ? value.toFixed(0) : value.toFixed(1)} ${units[unitIndex]}`;
}

export function formatEta(seconds: number | null): string {
  if (seconds === null || !Number.isFinite(seconds)) return "Estimating…";
  if (seconds < 2) return "Finishing…";
  if (seconds < 60) return `About ${Math.ceil(seconds)} sec left`;
  return `About ${Math.ceil(seconds / 60)} min left`;
}

export function friendlyFirebaseError(error: unknown): string {
  const fallback = "Something went wrong. Please try again.";
  if (!(error instanceof Error)) return fallback;
  const code = "code" in error ? String((error as Error & { code?: string }).code) : "";
  if (code === "auth/unauthorized-domain") {
    return "This website domain is not authorized for Google sign-in. Add it in Firebase Authentication settings.";
  }
  if (code === "auth/popup-closed-by-user") return "Sign-in was canceled before it finished.";
  if (code === "auth/popup-blocked") return "Your browser blocked the sign-in window. Allow popups and try again.";
  if (code.includes("unauthorized") || code.includes("permission-denied")) {
    return "You do not have permission to upload this clip.";
  }
  if (code.includes("canceled")) return "The upload was canceled.";
  if (code.includes("quota")) return "Storage is temporarily unavailable. Please try later.";
  if (code.includes("network")) return "Check your connection and try again.";
  return error.message || fallback;
}
